import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form, Modal, notification, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { deleteMouAction } from '../../../redux-store/mous-store';
import { deleteMouMutation } from '../constants';

const { Title, Text, Paragraph } = Typography;

const DeleteMouBtn = ({ mou, setError, error, queryId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [showingModal, setShowingModal] = useState(null);
  const [deleteMou] = useMutation(deleteMouMutation);
  const dispatch = useDispatch();

  const locale = useSelector((store) => store.locale, shallowEqual);

  const handleFinish = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      const result = await deleteMou({
        variables: {
          _id: mou._id,
        },
      });
      dispatch(deleteMouAction(result.data.deleteMou.deletedId, queryId));
      notification.success({
        message: 'Saved',
        description: 'Partnership Commitment Form deleted successfully',
      });
      setShowingModal(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
    setLoading(false);
  }, [setError, dispatch, queryId, deleteMou, mou, onSuccess]);

  return (
    <>
      <Button
        loading={loading}
        icon={<DeleteOutlined />}
        onClick={() => setShowingModal(true)}
      >
        Delete
      </Button>

      <Modal
        header={null}
        footer={null}
        visible={showingModal}
        closable={!loading}
        destroyOnClose={true}
        maskClosable={!loading}
        onCancel={() => {
          setShowingModal(false);
        }}
        styles={{ body: { paddingTop: 48 } }}
      >
        <Title level={3} style={{ textAlign: 'center', marginBottom: 32 }}>
          Delete Partnership Commitment Form
        </Title>
        <Form onFinish={handleFinish} layout="vertical">
          <Form.Item>
            <Paragraph style={{ textAlign: 'center' }}>
              You are about to delete this version of this Partnership
              Commitment Form.
            </Paragraph>
            <Paragraph style={{ textAlign: 'center' }}>
              Would you like to continue?
            </Paragraph>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <div
              style={{
                marginRight: -8,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                onClick={() => setShowingModal(null)}
                htmlType="button"
                disabled={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={loading}
                style={{ marginLeft: 8, marginRight: 8, marginBottom: 8 }}
              >
                Delete Partnership Commitment Form
              </Button>
            </div>
          </Form.Item>
        </Form>
        {error && (
          <Text type="danger" style={{ marginTop: 16 }}>
            {error}
          </Text>
        )}
      </Modal>

      <style jsx>{``}</style>
      <style jsx global>{``}</style>
    </>
  );
};

export default DeleteMouBtn;
